var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { m } from 'framer-motion';
import { useFlyoutVariants } from '../config';
import { FlyoutMenuZIndex } from '../../constants';
import { Backdrop } from '@spotify-internal/encore-web/core';
var backgroundAlpha = function (opacity) { return "rgba(0,0,0,".concat(opacity, ")"); };
var closedState = {
    backdropFilter: 'blur(0px)',
    background: backgroundAlpha(0)
};
export var FlyoutMenuBackdrop = React.forwardRef(function (_a, ref) {
    var children = _a.children, onClose = _a.onClose;
    var variants = useFlyoutVariants({
        initial: closedState,
        animate: {
            background: backgroundAlpha(0.44),
            backdropFilter: 'blur(15px)',
            WebkitBackdropFilter: 'blur(15px)'
        },
        exit: closedState
    });
    return (React.createElement(m.div, __assign({ layout: true, style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: FlyoutMenuZIndex
        }, key: "backdropblur", ref: ref }, variants),
        React.createElement(Backdrop, { onMouseMove: onClose, style: { background: 'transparent' } }, children)));
});
